import ImporterWebLayout from './ImporterWebLayout';

export default ImporterWebLayout;
